import { api } from '@/lib/api';
import { extractDiretoriaErpError } from '@/lib/diretoriaErpFetch';

export interface DiretoriaOficinaProdutividade {
  periodo: { dataFrom: string; dataTo: string };
  hoje: { osRealizadas: number; agendamentosConcluidos: number };
  wip: { emExecucao: number; mediaDias: number; criticas: number };
  agendamentos: {
    total: number;
    concluidos: number;
    noShow: number;
    taxaComparecimento: number | null;
    tempoMedioMinutos: number | null;
    npsScore: number | null;
    porClassificacao: Record<string, number>;
    porJanela: Record<string, { total: number; concluidos: number }>;
  };
  charts: {
    porTecnico: Array<{ tecnico: string; total: number }>;
    locacaoPorEmpresa: Array<{ empresa: string; emDia: number; atrasada: number }>;
  };
  tables: {
    tecnicoPorTipo: Array<{
      tecnico: string;
      expresso: number;
      intermediario: number;
      tipoTecnico: number;
      setorOutros: number;
      total: number;
    }>;
    locacaoPorEmpresa: Array<{
      empresaId: string;
      empresa: string;
      emDia: number;
      atrasada: number;
      total: number;
      pctAtrasada: number;
    }>;
  };
  locacaoPeriodo: { emDia: number; atrasada: number };
  updatedAt: string;
}

export function formatDateISO(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function startOfMonthISO(d = new Date()): string {
  return formatDateISO(new Date(d.getFullYear(), d.getMonth(), 1));
}

export function startOfWeekISO(d = new Date()): string {
  const copy = new Date(d);
  const day = copy.getDay();
  const diff = day === 0 ? 6 : day - 1;
  copy.setDate(copy.getDate() - diff);
  return formatDateISO(copy);
}

export async function fetchDiretoriaOficinaProdutividade(
  companyId: string,
  dataFrom: string,
  dataTo: string
): Promise<DiretoriaOficinaProdutividade | null> {
  try {
    const params = new URLSearchParams();
    if (companyId) params.append('companyId', companyId);
    params.append('dataFrom', dataFrom);
    params.append('dataTo', dataTo);
    const response = await api.get(`/reports/diretoria/oficina-produtividade?${params.toString()}`);
    return response.data.data as DiretoriaOficinaProdutividade;
  } catch (e: unknown) {
    const { status } = extractDiretoriaErpError(e);
    if ([403, 422, 502, 503].includes(status)) return null;
    throw e;
  }
}
